export default "__VITE_ASSET__Byk6wMjn__"